<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <modal size="medium"
           v-show="show"
           id="ModalCommissionsDraft">

        <template v-slot:header>
            <h3 class="title">Rascunhos de Comissões</h3>
        </template>

        <template v-slot:body>
            <div class="container">
                <div class="form-row" v-if="entity.proposals">
                    <div class="col-12">
                        <label class="required" for="comPayDraftName">Nome do Rascunho</label>
                        <div class="container-name">
                            <input type="text" id="comPayDraftName"
                                   v-model="name"
                                   maxlength="100"
                                   placeholder="Informe o identificador do rascunho"
                                   @keyup.enter="saveDraft"
                                   class="form-control form-control-sm not-b-r-top-right not-b-r-bottom-right"
                                   :class="{'is-invalid': errors.name}"
                                   required>
                            <button type="button"
                                    class="btn btn-theme-1 btn-sm not-b-r-top-left not-b-r-bottom-left"
                                    @click="saveDraft"><svg-icon icon="save"/> Salvar</button>
                        </div>
                        <field-messages :errors="errors.name"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <br>
                        <table v-if="$appUtils.isDesktop()" class="table table-hover table-striped table-sm table-bordered">
                            <thead class="thead-dark thead-center">
                            <tr>
                                <th>Identificador</th>
                                <th>Corretor</th>
                                <th>Data</th>
                                <th>Contratos</th>
                                <th>Valor</th>
                                <th style="width: 30px"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="k in draftKeys" :key="k">
                                <td class="c-p" @click="selectDraft(drafts[k])">{{k}}</td>
                                <td class="c-p" @click="selectDraft(drafts[k])">{{drafts[k].entity.broker_name}}</td>
                                <td class="t-c c-p" @click="selectDraft(drafts[k])">{{drafts[k].date | formatDateHourMin}}</td>
                                <td class="t-c c-p" @click="selectDraft(drafts[k])">{{drafts[k].entity.proposals.length}}</td>
                                <td class="t-r c-p" @click="selectDraft(drafts[k])">{{drafts[k].entity.value}}</td>
                                <td class="t-c">
                                    <button type="button"
                                            @click="destroyDraft(k)"
                                            class="btn btn-xs btn-danger">
                                        <svg-icon icon="trash-alt"/>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="draftKeys.length === 0">
                                <td colspan="6" class="t-c f-w-700">Não há rascunhos salvos</td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-else>
                            <div class="list-card" v-for="k in draftKeys" :key="k">
                                <h3>{{k}} ({{drafts[k].entity.proposals.length}})</h3>
                                <div class="broker f-w-700">{{drafts[k].entity.broker_name}}</div>
                                <span class="dt">{{drafts[k].date | formatDateHourMin}}</span>
                                <span class="val">R$ {{drafts[k].entity.value}}</span>
                                <div class="act">
                                    <button type="button"
                                            @click="selectDraft(drafts[k])"
                                            class="btn btn-xs btn-theme-1">
                                        <svg-icon icon="check"/>
                                    </button>
                                    <button type="button"
                                            @click="destroyDraft(k)"
                                            class="btn btn-xs btn-danger">
                                        <svg-icon icon="trash-alt"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button type="button"
                    @click="$emit('onClose')"
                    class="btn btn-sm btn-dark">
                <svg-icon icon="times"/>
                Fechar
            </button>
        </template>
    </modal>
</template>

<script>
    const KEY_DRAFT_STORAGE = '__KEY_DRAFT_STORAGE';
    export default {
        name: "ModalDrafts",
        props: {
            showModal: {
                type: Boolean,
                default: false
            },
            entity: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                drafts: {},
                errors: {},
                name: null,
            }
        },
        methods: {
            saveDraft() {
                this.errors = {};
                if (this.$appUtils.isEmpty(this.name)) {
                    this.$set(this.errors, 'name', ['Preencha o nome do rascunho'])
                } else {
                    this.$set(this.drafts, this.name.trim(), {
                        date: new Date(),
                        entity: this.entity
                    });
                    this.$appStorage.saveObject(KEY_DRAFT_STORAGE, this.drafts);
                    this.name = null;
                    this.$snotify.success('Rascunho salvo com sucesso.', this.$appStorage.getUser().name);
                }
            },
            destroyDraft(k) {
                this.$delete(this.drafts, k);
                this.$appStorage.saveObject(KEY_DRAFT_STORAGE, this.drafts);
                this.$snotify.success('Rascunho removido com sucesso.', this.$appStorage.getUser().name);
            },
            selectDraft(draft) {
                const result = {
                    broker_id: draft.entity.broker_id,
                    proposals: draft.entity.proposals
                };

                this.$emit('onSelectDraft', result);
            }
        },
        computed: {
            show() {
                if (this.showModal) {
                    const drafts = this.$appStorage.getObject(KEY_DRAFT_STORAGE);
                    if (drafts) this.drafts = drafts;
                    this.errors = {};
                }
                return this.showModal
            },
            draftKeys() {
                return Object.keys(this.drafts)
            }
        }
    }
</script>

<style scoped lang="scss">
    .container-name {
        display: grid;
        grid-template-columns: auto 100px;
        grid-template-rows: auto;
        grid-template-areas: 'ipt btn';


        label {
            grid-area: lbl;
        }

        input {
            grid-area: ipt;
        }

        button {
            grid-area: btn;
        }
    }

    .list-card {
        display: grid;
        width: 100%;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
        grid-template-areas: "tlt tlt" "broker broker" "dt val" "act act" ;
        grid-gap: 5px;
        font-size: .8em;
        padding: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        h3{
            grid-area: tlt;
            text-align: center;
        }

        .broker {
            grid-area: broker;
        }

        .dt{
            grid-area: dt;
        }
        .val {
            grid-area: val;
            text-align: right;
        }

        .act{
            grid-area: act;
            text-align: right;
            .btn:not(:last-child) {
                margin-right: 5px;
            }
        }
    }
</style>
